import { PageActionRenderer } from 'app/components/BasicTable/PageActions/PageActionsRenderer';
import { AddRegion } from './AddRegion';

interface GetPageActionsProps {
  isAdmin: boolean;
}

export function GePageActions(
  props: GetPageActionsProps,
): PageActionRenderer[] {
  const PageActions = props.isAdmin
    ? [(dataCount, refresh) => <AddRegion />]
    : [];
  return PageActions;
}
